import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { ButtonContainer } from "styles/components/Button";

const Button = (props) => {
  return (
    <ButtonContainer
      type={props?.buttonType ? props?.buttonType : "submit"}
      id={props?.id}
      style={props?.style}
      className={`${props?.type ? `button ${props?.type}` : "button"}`}
      onClick={(e) => _.isFunction(props?.handleClick) && props?.handleClick(e)}
      disabled={props?.disabled}
    >
      {props?.children}
    </ButtonContainer >
  );
};

Button.propTypes = {
  type: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

Button.defaultProps = {
  id: "",
};

export default Button;
